<template>
	<div class="default">
		<h1><img src="~appAsset/ic_error.png" alt=""></h1>
		<p>页面找不到了....<a href="javascript:history.go(-1);">返回上一页</a></p>
	</div>
</template>
<script type="text/javascript">
export default{
	name: "default",
	data(){
		return{
		}
	}
}
</script>

<style lang="scss">
	.default {
		width: 100%;
		height: 100%;
		background-color: #fff;
		padding-top: 50px;
		text-align: center;
		h1 {
			font-size: 350px;
			font-weight: bold;
			color: #cb6767;
		}
		p {
			color: #626262;
			margin-top: 20px;
			a {
				margin-left: 10px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// default.vue?0068587f